/**
 * «Nessun filtro» nei combobox dei popover «Filtri». Fuori dal dominio dei
 * valori veri (enum maiuscoli e UUID) e mai scritto nell'URL: l'assenza di
 * filtro è l'assenza del parametro.
 */
export const LIST_FILTER_ALL = '__all__';

/** URL → form: un parametro assente vale «tutti». */
export function toFilterFormValue(param: string | null | undefined): string {
  if (!param || param === LIST_FILTER_ALL) return LIST_FILTER_ALL;
  return param;
}

/**
 * Form → URL: `null` per «tutti», così il parametro sparisce invece di
 * restare come filtro che il backend rifiuterebbe con 400.
 */
export function toFilterParam(value: string | null | undefined): string | null {
  if (!value || value === LIST_FILTER_ALL) return null;
  return value;
}
